import React from 'react';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import {useText} from './TextContext';

const Tooltip = props => {
  const {
    attributes,
    messageId,
    content,
    iconRender = <i className="fa fa-info-circle" alt="Info Circle Icon" />,
    className,
    type,
  } = props;

  const classes = classnames('toolTip', className);
  const textContext = useText();

  const anchorProps = attributes?.anchor;
  const tooltipProps = attributes?.tooltip;

  return (
    <>
      <span
        aria-describedby={messageId}
        className={classes}
        data-tip="custom show"
        data-event="touchstart click focus mouseenter"
        data-event-off="blur mouseleave"
        data-type={type}
        data-for={messageId}
        tabIndex="0"
        {...anchorProps}
      >
        {iconRender}
      </span>
      <ReactTooltip
        id={messageId}
        effect="solid"
        role="tooltip"
        tagName="p"
        globalEventOff="touchstart"
        {...tooltipProps}
      >
        {content || textContext?.[`${messageId}`] || <FormattedMessage id={messageId} />}
      </ReactTooltip>
    </>
  );
};

Tooltip.propTypes = {
  attributes: PropTypes.object,
  messageId: PropTypes.any,
  content: PropTypes.any,
  iconRender: PropTypes.any,
  className: PropTypes.string,
  type: PropTypes.string,
};

export default Tooltip;
